import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { concatLatestFrom } from '@ngrx/operators';
import { filter, mergeMap } from 'rxjs';

import { DocsActions } from '../docs/docs.actions';
import { selectActiveProjectId } from '../workspace/workspace.selectors';
import { GlobalChatActions } from './global-chat.actions';
import { compactChatMessages } from './global-chat.models';

const loadGlobalChat$ = createEffect(
  (actions$ = inject(Actions), store = inject(Store)) =>
    actions$.pipe(
      ofType(GlobalChatActions.load),
      concatLatestFrom(() => store.select(selectActiveProjectId)),
      filter(([, pid]) => !!pid),
      mergeMap(([, pid]) => [DocsActions.loadDoc({ projectId: pid as string, key: 'project.globalChat' })])
    ),
  { functional: true }
);

const setChatMessages$ = createEffect(
  (actions$ = inject(Actions), store = inject(Store)) =>
    actions$.pipe(
      ofType(GlobalChatActions.setChatMessages),
      concatLatestFrom(() => store.select(selectActiveProjectId)),
      filter(([, pid]) => !!pid),
      mergeMap(([{ messages }, pid]) => {
        const data = { messages: compactChatMessages(messages) };
        return [
          DocsActions.applyLocalData({ projectId: pid as string, key: 'project.globalChat', data }),
          DocsActions.saveDoc({ projectId: pid as string, key: 'project.globalChat', data }),
        ];
      })
    ),
  { functional: true }
);

export const globalChatEffects = { loadGlobalChat$, setChatMessages$ };
